import allowed from '@/core/constants/allowed-roles.constant'

const index = [
  {
    name: 'Unsafe Conditions',
    path: '/safety-management',
    meta: {
      requiresAuth: true,
      layout: 'home',
      module: 'unsafe-conditions',
      allowedRoles: [...allowed.unsafe_conditions.roles],
    },
    children: [
      {
        name: 'Unsafe Conditions Home',
        path: 'unsafe-conditions',
        component: () =>
          import(
            '@/modules/unsafe-conditions/containers/unsafe-conditions.container.vue'
          ),
      },
      {
        name: 'New Unsafe Condition',
        path: 'unsafe-conditions/new',
        component: () =>
          import(
            '@/modules/unsafe-conditions/components/unsafe-condition-form/unsafe-condition-form.vue'
          ),
      },
      {
        name: 'Unsafe Condition Details',
        path: 'unsafe-conditions/:id',
        component: () =>
          import(
            '@/modules/unsafe-conditions/components/alert-details/alert-details.vue'
          ),
      },
    ],
  },
]

export default index
